<!-- ═══ Widget Carte — Rayon d'action & événements ═══ -->

<!-- Toast notification -->
@if (toastVisible) {
  <div
    class="fixed top-4 right-4 z-[9999] bg-white dark:bg-slate-800 shadow-lg dark:shadow-slate-900/50 rounded-lg border border-gray-200 dark:border-slate-700 p-4 flex items-start gap-3 min-w-[320px] animate-slide-in-right"
    style="animation: slideInRight 0.3s ease-out"
  >
    <div class="text-green-500 text-xl">✓</div>
    <div class="flex-1">
      <p class="font-semibold text-gray-900 dark:text-white text-sm">
        {{ toastMessage }}
      </p>
    </div>
    <button
      (click)="toastVisible = false"
      class="text-gray-400 hover:text-gray-600 dark:text-gray-400 text-lg leading-none"
    >
      ×
    </button>
  </div>
}

<section
  class="bg-white dark:bg-slate-800 rounded-xl shadow-sm dark:shadow-slate-900/30 overflow-hidden transition-all duration-200"
  [class.fixed]="isFullscreen"
  [class.inset-0]="isFullscreen"
  [class.rounded-none]="isFullscreen"
  [style.z-index]="isFullscreen ? 10000 : null"
  [class.zoom-active]="mapZoomActive"
>
  <!-- Header -->
  <div
    class="flex items-center justify-between px-4 py-3 border-b border-gray-100 dark:border-slate-700 relative z-10 bg-white dark:bg-slate-800"
  >
    <div class="flex items-center gap-3">
      <!-- Logo Predivent (visible uniquement en fullscreen) -->
      @if (isFullscreen) {
        <a
          (click)="goToDashboard()"
          class="flex items-center cursor-pointer mr-2 pr-3 border-r border-gray-200 dark:border-slate-600"
        >
          <div
            class="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-600 to-indigo-600 flex items-center justify-center mr-2"
          >
            <span class="text-white text-sm font-bold">P</span>
          </div>
          <span
            class="text-lg font-bold bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent"
            >Predivent</span
          >
        </a>
      }
      <h2
        class="text-base font-bold text-gray-900 dark:text-white flex items-center gap-2"
      >
        <span>🗺️</span> Ma zone d'activité
      </h2>
    </div>
    <div class="flex items-center gap-2">
      <!-- Bouton recentrer -->
      <button
        (click)="centerOnMerchant()"
        class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition"
        title="Recentrer"
      >
        🎯
      </button>
      <!-- Bouton fullscreen -->
      <button
        (click)="toggleFullscreen()"
        class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition"
        [class.bg-red-100]="isFullscreen"
        [class.text-red-600]="isFullscreen"
        [class.hover:bg-red-200]="isFullscreen"
        [title]="isFullscreen ? 'Quitter plein écran' : 'Plein écran'"
      >
        {{ isFullscreen ? "✖️" : "⛶" }}
      </button>
    </div>
  </div>

  <!-- Carte -->
  <div
    class="relative"
    [style.height]="
      isFullscreen ? 'calc(100vh - 56px)' : isExpanded ? '420px' : mapHeight()
    "
  >
    <div #mapContainer class="w-full h-full"></div>

    <!-- Légende flottante en bas à gauche + Slider rayon si agrandi/fullscreen -->
    <div
      class="absolute bottom-2 left-2 z-[1000] bg-white dark:bg-slate-800/90 backdrop-blur-sm rounded-lg px-3 py-2 shadow-sm dark:shadow-slate-900/30 border border-gray-200 dark:border-slate-700 text-xs"
    >
      <div class="flex items-center gap-3 flex-wrap">
        <button
          type="button"
          (click)="onLegendMerchantClick()"
          class="flex items-center gap-1 hover:text-indigo-700 dark:text-indigo-300 transition px-2 py-1 rounded"
          [class.font-bold]="activeLegendFilter === 'merchant'"
          [class.bg-indigo-50]="activeLegendFilter === 'merchant'"
          [class.ring-2]="activeLegendFilter === 'merchant'"
          [class.ring-indigo-400]="activeLegendFilter === 'merchant'"
          title="Cliquez pour filtrer : Ma position uniquement"
        >
          <span
            class="w-2.5 h-2.5 rounded-full bg-blue-600 inline-block"
          ></span>
          Ma position
        </button>
        <button
          type="button"
          (click)="onLegendEventsClick()"
          class="flex items-center gap-1 hover:text-indigo-700 dark:text-indigo-300 transition px-2 py-1 rounded"
          [class.font-bold]="activeLegendFilter === 'events'"
          [class.bg-indigo-50]="activeLegendFilter === 'events'"
          [class.ring-2]="activeLegendFilter === 'events'"
          [class.ring-indigo-400]="activeLegendFilter === 'events'"
          title="Cliquez pour filtrer : Mes événements uniquement"
        >
          <span
            class="w-2.5 h-2.5 rounded-full bg-purple-600 inline-block"
          ></span>
          Mes événements ({{ eventsInRadius }})
        </button>
        <button
          type="button"
          (click)="onLegendOpportunitiesHighClick()"
          class="flex items-center gap-1 hover:text-indigo-700 dark:text-indigo-300 transition px-2 py-1 rounded"
          [class.font-bold]="activeLegendFilter === 'opp-high'"
          [class.bg-indigo-50]="activeLegendFilter === 'opp-high'"
          [class.ring-2]="activeLegendFilter === 'opp-high'"
          [class.ring-indigo-400]="activeLegendFilter === 'opp-high'"
          title="Cliquez pour filtrer : Opportunités haute rentabilité uniquement"
        >
          <span
            class="w-2.5 h-2.5 rounded-full bg-green-500 inline-block"
          ></span>
          Opp. High ({{ oppsHighInRadius }})
        </button>
        <button
          type="button"
          (click)="onLegendOpportunitiesMediumClick()"
          class="flex items-center gap-1 hover:text-indigo-700 dark:text-indigo-300 transition px-2 py-1 rounded"
          [class.font-bold]="activeLegendFilter === 'opp-medium'"
          [class.bg-indigo-50]="activeLegendFilter === 'opp-medium'"
          [class.ring-2]="activeLegendFilter === 'opp-medium'"
          [class.ring-indigo-400]="activeLegendFilter === 'opp-medium'"
          title="Cliquez pour filtrer : Opportunités rentabilité moyenne uniquement"
        >
          <span
            class="w-2.5 h-2.5 rounded-full bg-yellow-400 inline-block"
          ></span>
          Opp. Medium ({{ oppsMediumInRadius }})
        </button>
        <button
          type="button"
          (click)="onLegendOpportunitiesLowClick()"
          class="flex items-center gap-1 hover:text-indigo-700 dark:text-indigo-300 transition px-2 py-1 rounded"
          [class.font-bold]="activeLegendFilter === 'opp-low'"
          [class.bg-indigo-50]="activeLegendFilter === 'opp-low'"
          [class.ring-2]="activeLegendFilter === 'opp-low'"
          [class.ring-indigo-400]="activeLegendFilter === 'opp-low'"
          title="Cliquez pour filtrer : Opportunités faible rentabilité uniquement"
        >
          <span
            class="w-2.5 h-2.5 rounded-full bg-orange-500 inline-block"
          ></span>
          Opp. Low ({{ oppsLowInRadius }})
        </button>

        <!-- Slider rayon d'action (visible en mode agrandi / plein écran) -->
        @if (isFullscreen || isExpanded) {
          <div
            class="flex items-center gap-2 px-2 py-1 border-l border-gray-300 dark:border-slate-600 ml-2"
          >
            <span class="text-indigo-600 font-semibold whitespace-nowrap"
              >⊙ {{ radiusValue }} km</span
            >
            <input
              type="range"
              [(ngModel)]="radiusValue"
              (ngModelChange)="onRadiusChange()"
              [min]="1"
              [max]="100"
              [step]="1"
              class="w-32 h-1.5 bg-indigo-200 rounded-lg appearance-none cursor-pointer accent-indigo-600"
            />
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Rayon d'action -->
  <div
    class="px-4 py-3 bg-gray-50 dark:bg-slate-900 border-t border-gray-100 dark:border-slate-700"
  >
    <div class="flex items-center justify-between mb-1">
      <label class="text-xs font-medium text-gray-600 dark:text-gray-400">
        Rayon d'action :
        <span class="font-bold text-indigo-600">{{ radiusValue }} km</span>
      </label>
      <span class="text-xs text-gray-400">
        {{ displayOppCount }} opportunité{{ displayOppCount > 1 ? "s" : "" }},
        {{ eventsInRadius }} événement{{ eventsInRadius > 1 ? "s" : "" }} dans
        la zone
      </span>
    </div>
    <input
      type="range"
      [(ngModel)]="radiusValue"
      (ngModelChange)="onRadiusChange()"
      [min]="1"
      [max]="100"
      [step]="1"
      class="w-full h-1.5 bg-gray-200 dark:bg-slate-700 rounded-lg appearance-none cursor-pointer accent-indigo-600"
    />
    <div class="flex justify-between text-[10px] text-gray-400 mt-0.5">
      <span>1 km</span>
      <span>25 km</span>
      <span>100 km</span>
    </div>
  </div>
</section>
